<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from "@/Shared/Navigation/TabNavigator";
import RainbooIcon from "@/Shared/SVG/RainbooIcon";
import ContactPanner from "@/Shared/ContactPanner";

import { Navigation, Pagination} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/vue/24/solid';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ReasonCards from "@/Shared/ReasonCards";

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'Game Hub', href: route('gaming.gameHub'), current: true },
    { name: 'Game Store', href: route('gaming.gameStore'), current: false },
    { name: 'XWGT', href: route('gaming.xwgt'), current: false },
    { name: 'Marketplace', href: route('gaming.marketplace'), current: false },
    { name: 'Incubation', href: route('gaming.incubation'), current: false },
    { name: 'Hosting', href: route('gaming.hosting'), current: false },
    { name: 'Development', href: route('gaming.development'), current: false },
];

</script>

<template>
    <div class="w-full relative">
        <TabNavigator :tabs="tabNavigation" />
        <h1 class="text-white text-3xl font-bold mt-12 sm:mt-16 text-center px-2 max-w-lg m-auto font-bold">{{data.title}}</h1>
        <div class="mt-28 sm:mt-20 mb-40 relative">
            <div class="flex flex-col sm:grid grid-cols-12">
                <div class=" col-span-12">
                    <img class="rounded-2xl w-full max-w-[1024px]  m-auto" :src="data.main_image" :alt="data.title" />
                </div>
                <div class="mt-10 col-span-12">
                    <h2 class="text-white text-[26px] font-bold">{{data.section_1.title}}</h2>
                    <div class="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-5">
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_1}}</p></div>
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_2}}</p></div>
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_3}}</p></div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-10 grid grid-cols-12">
                <div class="col-start-2 col-span-10 col-end-12">
                    <div class="flex flex-col lg:flex-row justify-start lg:space-x-10 space-y-6 lg:space-y-0 items-center">
                        <div class="w-full"><img class="rounded-2xl w-full m-auto" :src="data.section_2.image" :alt="data.section_2.title" /></div>
                        <div class="w-full">
                            <h2 class="text-white text-[26px] font-bold mb-4">{{data.section_2.title}}</h2>
                            <p class="text-white text-opacity-60">{{data.section_2.paragraph_1}}</p>
                            <p class="text-white text-opacity-60 mt-3">{{data.section_2.paragraph_2}}</p>
                            <p class="text-white text-opacity-60 mt-3">{{data.section_2.paragraph_3}}</p>
                            <div class="mt-8">
                                <p><a :href="data.website" target="_blank" rel="noopener noreferrer" class="px-6 py-2 text-wgn-purple-2 bg-white text-base rounded-[40px] w-fit">{{data.website_btn}}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--            -->
            <div class="mt-10 grid grid-cols-12">
                <div class="col-start-2 col-span-10 col-end-12">
                    <div class="flex flex-col lg:flex-row justify-start lg:space-x-10 space-y-6 lg:space-y-0 items-center">
                        <div class="w-full">
                            <div
                                class="gradient-slogan mb-2 text-xl font-semibold tracking-[1%] uppercase"
                            >
                                {{ data.section_7.slogan }}
                            </div>
                            <div
                                class="mb-4 text-3xl font-extrabold tracking-[1%] text-wgn-white-1"
                            >
                                {{ data.section_7.title }}
                            </div>
                            <p class="mb-2 text-white text-opacity-60 mt-3">
                                {{ data.section_7.description_1 }}
                            </p>
                            <p class="mb-10 text-white text-opacity-60 mt-3">
                                {{ data.section_7.description_2 }}
                            </p>
                        </div>

                        <div
                            class="mb-10 flex w-full items-center md:mb-0"
                        >
                            <img
                                :src="data.section_7.cards"
                                alt="Wodo Cards"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto"/>
            </div>
            <div class="mt-3">
                <h2 class="text-white text-[22px] mb-7 text-center">{{data.section_3.title}}</h2>
                <ReasonCards :cards="data.section_3.cards"></ReasonCards>
            </div>
            <!--            -->
            <div class="mt-20">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-y-5 gap-x-5">
                    <div class="flex flex-col pl-4 border-l-4 border-white border-opacity-20" v-for="number in data.section_4.numbers">
                        <div class="relative flex-1">
                            <span class="w-8 h-8" v-html="number.icon"></span>
                            <h3 class="text-[40px] md:text-[54px] font-medium text-white mt-1.5">{{number.value}}</h3>
                            <p class="mt-1.5 text-base md:text-xl text-white text-opacity-60">{{number.title}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto"/>
            </div>
            <div class="mt-3">
                <h2 class="text-white text-[22px] mb-7 text-center">{{data.section_5.title}}</h2>
                <div class="flex justify-center max-w-[800px] m-auto">
                    <div class="hidden md:flex mr-5">
                        <div class="image_swiper_button_prev m-auto">
                            <div class="rounded-full bg-white rounded-full w-8 h-8">
                                <ArrowLeftIcon class="text-wgn-black-1 h-full w-4 m-auto"></ArrowLeftIcon>
                            </div>
                        </div>
                    </div>

                    <div class="w-full">
                        <div class="max-w-[798px] max-h-[444px]">
                            <div class="flex flex-col relative">
                                <swiper class="grid grid-cols-1 w-full m-auto"
                                        :breakpoints="{
                                            1: {slidesPerView:1},
                                            640: {slidesPerView:1},
                                            1024: {slidesPerView:1}
                                        }"
                                        :space-between="16"
                                        :loop="true"
                                        :pagination="{
                                          el: '.image_pagination',
                                          clickable: true,
                                        }"
                                        paginationClickable: true
                                        :modules="[Pagination, Navigation]"
                                        :navigation= "{
                                            nextEl: '.image_swiper_button_next',
                                            prevEl: '.image_swiper_button_prev'
                                        }"
                                >
                                    <swiper-slide v-for="image in data.section_5.images">
                                        <img class="rounded-2xl w-full max-h-[444px] bg-" alt="gamehub" :src="image" />
                                    </swiper-slide>
                                </swiper>
                                <div class="mt-4 md:mt-6 image_pagination text-center" slot="pagination"></div>
                            </div>
                        </div>
                    </div>

                    <div class="hidden md:flex ml-5">
                        <div class="image_swiper_button_next m-auto">
                            <div class="rounded-full bg-white rounded-full w-8 h-8">
                                <ArrowRightIcon class="text-wgn-black-1 h-full w-4 m-auto"></ArrowRightIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto"/>
            </div>
            <div class="mt-3">
                <h2 class="text-white text-[22px] mb-7 text-center">{{data.section_6.title}}</h2>
                <div class="flex justify-center max-w-[800px] m-auto">
                    <div class="hidden md:flex mr-5">
                        <div class="video_swiper_button_prev m-auto">
                            <div class="rounded-full bg-white rounded-full w-8 h-8">
                                <ArrowLeftIcon class="text-wgn-black-1 h-full w-4 m-auto"></ArrowLeftIcon>
                            </div>
                        </div>
                    </div>

                    <div class="w-full">
                        <div class="max-w-[798px] max-h-[444px]">
                            <div class="flex flex-col relative">
                                <swiper class="grid grid-cols-1 w-full m-auto"
                                        :breakpoints="{
                                            1: {slidesPerView:1},
                                            640: {slidesPerView:1},
                                            1024: {slidesPerView:1}
                                        }"
                                        :space-between="16"
                                        :loop="true"
                                        :pagination="{
                                          el: '.video_pagination',
                                          clickable: true,
                                        }"
                                        paginationClickable: true
                                        :modules="[Pagination, Navigation]"
                                        :navigation= "{
                                            nextEl: '.video_swiper_button_next',
                                            prevEl: '.video_swiper_button_prev'
                                        }"
                                >
                                    <swiper-slide class="aspect-w-16 aspect-h-9" v-for="video in data.section_6.videos">
                                        <span class="w-full " v-html="video"></span>
                                    </swiper-slide>
                                </swiper>
                                <div class="mt-4 md:mt-6 video_pagination text-center" slot="pagination"></div>
                            </div>
                        </div>
                    </div>

                    <div class="hidden md:flex ml-5">
                        <div class="video_swiper_button_next m-auto">
                            <div class="rounded-full bg-white rounded-full w-8 h-8">
                                <ArrowRightIcon class="text-wgn-black-1 h-full w-4 m-auto"></ArrowRightIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20">
                <ContactPanner></ContactPanner>
            </div>
        </div>
    </div>
</template>

<style>
.gradient-slogan {
    background: linear-gradient(
        180deg,
        #9770e5 0%,
        #cebfec 165.81%,
        rgba(238, 237, 240, 0.5) 261.11%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
